import React, { useState } from "react";
import dayjs from "dayjs";
import LBox from "@components/LBox";
import StatsHeader from "./StatsHeader";
import Divider from "@components/Divider";
import StatsIncome from "@components/Stats/StatsIncome";
import StatsStreams from "@components/Stats/StatsStreams";
import { useGetStats } from "@hooks/trpc/useManagedArtists";

const Stats = () => {
  const [month, setMonth] = useState(dayjs());
  const { data: revenue } = useGetStats({ from: month });

  return (
    <LBox>
      <StatsHeader month={month} onChangeMonth={setMonth} />
      <LBox
        backgroundColor="favouriteTileBg"
        borderTopLeftRadius="zero"
        borderTopRightRadius="zero"
        borderBottomLeftRadius="l"
        borderBottomRightRadius="l"
        px="l1"
        py="m1"
      >
        <StatsIncome revenue={revenue} />
        <Divider my="m1" />
        <StatsStreams month={month} stats={revenue?.by_date} />
      </LBox>
    </LBox>
  );
};

export default Stats;
